module.exports = __webpack_public_path__ + "static/img/3.c08469c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/3.png
// module id = LXNz
// module chunks = 0